module.exports = __webpack_public_path__ + "static/media/ios-cut.400954d3.svg";